export enum UserClassification {
  RETENTION_ADMIN = 'RETENTION_ADMIN',
  AODOCS_SUPER_ADMIN = 'AODOCS_SUPER_ADMIN',
  USER = 'USER',
  AUDITOR = 'AUDITOR'
}
